<template>
  <div v-if="user" class="view-profile container" style="min-height: 700px;">
    <div class="row margin-bottom-10 margin-top-20">
      <div class="col-12">
        <div class="card afas-gold">
          <div class="card-content">
            <h5 class="margin-top-10 margin-bottom-10 white-text">Settings</h5>
            <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
          </div>
        </div>
      </div>
    </div>
        <div class="progress" v-if="loading">
            <div class="indeterminate"></div>
          </div>
    <div class="card" v-if="!loading">
      <div class="col-12 card-content">
        <form @submit.prevent="editUser">
          <div class="row margin-top-20">
            <div class="col-12">
              <label for="name">E-Mail</label>
              <input type="text" v-model="user.email" :disabled="true" />
            </div>
          </div>
          <div class="row margin-top-20">
            <div class="col-12">
              <label for="name">Name</label>
              <input type="text" v-model="user.displayName" />
            </div>
          </div>
          <div class="row margin-top-20">
            <div class="col-12">
              <label for="license">License plate number</label>
              <input type="text" v-model="user.photoURL" />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="red-text" v-if="feedback">{{ feedback }}</p>
              <p class="teal-text" v-if="successFeedback">{{ successFeedback }}</p>
              <button class="btn teal margin-top-20">Save Changes</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import firebase from "firebase";
export default {
  name: "Profile",
  data() {
    return {
      user: null,
      feedback: null,
      successFeedback: null,
      loading: true,
    };
  },
  methods: {
    editUser() {
      this.feedback = null;
      this.successFeedback = null;
      var user = firebase.auth().currentUser;

      console.log(this.user.licensePlate)

      user
        .updateProfile({
          displayName: this.user.displayName,
          photoURL: this.user.photoURL,
        })
        .then(() => {
          // Update successful.
          this.successFeedback = "Changes have been saved successfully.";
          setTimeout(()=> {
              this.$router.push({ name: 'Locations' });
          }, 750)
        })
        .catch((error) => {
          console.log(error);
          // An error happened.
          this.feedback = error;
        });
    },
    goBack() {
        this.$router.go(-1);
    }
  },
  async created() {
    var firebaseUser = await firebase.auth().currentUser;
    console.log(firebaseUser)
    this.user = firebaseUser;
    this.loading = false;
  },
};
</script>

<style>
.view-profile h2 {
  font-size: 2em;
  margin-top: 0;
}

.view-profile li {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

    .view-profile-card {
        position: relative;
    }

    .view-profile .back-button {
        position: absolute;
        top: 15px;
        right: 15px;;
    }
</style>


// WEBPACK FOOTER //
// src/components/profile/Profile.vue